export const SET_TAX_RATE = 'SET_TAX_RATE';
export const SET_INSTALL_YEAR = 'SET_INSTALL_YEAR';
export const SET_TAX_ENTITY = 'SET_TAX_ENTITY';
export const SET_RESI_TOGGLE = 'SET_RESI_TOGGLE';
export const SET_TAX_IPUTS = 'SET_TAX_IPUTS';



// WEBPACK FOOTER //
// ./src/containers/common/tax/constants.js